<template>
  <div v-if="showModal">
    <transition name="modal">
      <div class="modal-mask">
        <div
          class="modal-wrapper"
          @click.self="hideModal"
        >
          <div
            id="modalContainer"
			:class="'modal-container ' + (isMyAccountModal ? 'myaccount-modal' : '')"
          >
            <button v-if="isMyAccountModal" class="modal-close-btn" @click="hideModal">Close</button>
            <div v-else class="modal-close" @click="hideModal" />

            <div class="modal-header">
              <slot name="header" />
			  <h2 v-if="isMyAccountModal">My Account</h2>
            </div>

            <div class="modal-body">
              <slot name="body">
                <component
                  :is="showComponent"
                  v-bind="props"
                />
              </slot>
            </div>

            <div class="modal-footer">
              <slot name="footer" />
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import AccountPage from '@/components/AccountPage'
import SignIn from '@/components/Cards/SignIn'
import * as menuConstants from '../constants/menu'

export default {
	name: 'Modal',
	components: {
		AccountPage,
		SignIn
	},
	data () {
		return {
			isMyAccountModal: false,
		}
	},
	computed: {
		showModal: function () {
			return this.$store.getters.modal['show']
		},
		showComponent: function () {
			return this.$store.getters.modal['component']
		},
		props: function () {
			return this.$store.getters.modal['props']
		}
	},
	mounted () {
		// show_modal in url
		if (this.getUrlParameter('showModal') === 'signIn') {
			let modalPayload = {
				'component': 'SignIn',
				'props': {}
			}
			this.$store.dispatch('showModal', modalPayload)
		}

		this.isMyAccountModal = [
			menuConstants.URL_HASH_INVOICES,
			menuConstants.URL_HASH_INVOICE_ITEM,
			menuConstants.URL_HASH_ACCOUNT_DETAILS,
			menuConstants.URL_HASH_BIDS,
			menuConstants.URL_HASH_FAVORITES,
			menuConstants.URL_HASH_NOTIFICATIONS,
			menuConstants.URL_HASH_CONSIGNMENTS,
		].indexOf(window.location.hash) != -1;
	},
	methods: {
		getUrlParameter: function (name) {
			 
			name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]')
			var regex = new RegExp('[\\?&]' + name + '=([^&#]*)')
			var results = regex.exec(location.search)
			return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '))
		},
		hideModal () {
			this.$store.dispatch('hideModal')
			this.$store.dispatch('clearAllAccountHistory')
			window.location.hash = ''
		}
	}
}
</script>

<style scoped>
#modalContainer.myaccount-modal {
	overflow: hidden;
	border-radius: 12px;
	background: #fff;

	& > .modal-body {
		overflow-y: scroll;
		height: calc(100% - 2rem);
		display: block;
	}

	& > .modal-close-btn {
		position: absolute;
		right: 8.2rem;
		border-radius: 8px;
		border: 1px solid #333333B2;
		min-width: unset !important;
		padding: 0px 20px;
	}
}
</style>
